export const NotificationSettingsPage = () => {
  return (
    <>
      <h1>notification settings page</h1>
    </>
  );
};
